import { useState, useEffect } from "react";
import { fetchPerceptionData, type TimeRange, type PerceptionDataResponse } from "@/app/services/analytics/perception-api";
import { useAnalyticsRefreshTrigger } from "./useAnalyticsRefreshTrigger";

export function usePerceptionData(
  timeRange: TimeRange,
  antennaData?: any,
  selectedModels?: string[],
) {
  const [data, setData]           = useState<PerceptionDataResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError]         = useState<Error | null>(null);
  const refreshKey                = useAnalyticsRefreshTrigger();

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setError(null);
    fetchPerceptionData(timeRange, antennaData, selectedModels)
      .then(r  => { if (!cancelled) { setData(r); setIsLoading(false); } })
      .catch(e => { if (!cancelled) { setError(e instanceof Error ? e : new Error(String(e))); setIsLoading(false); } });
    return () => { cancelled = true; };
  // antennaData is a fallback — not a reactive trigger. refreshKey handles
  // re-fetching after Run Now via the analytics:refresh event.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeRange, refreshKey]);

  return { data, isLoading, error };
}